import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Breadcrumb, Table } from "@themesberg/react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../Routes/BaseUrl";
import moment from "moment";
export default () => {
  const { id } = useParams();
  console.log(id);
  const [doctorDetails, setDoctorDetails] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchDoctorDetails = async () => {
      try {
        const response = await axios.get(
          `${BaseUrl.trim()}/doctor/getDoctorProfileById/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const doctor = response.data.data;
        console.log(doctor);
        setDoctorDetails(doctor);
      } catch (error) {
        console.error("Error fetching doctor details:", error);
      }
    };
    fetchDoctorDetails();
  }, [id]);

  if (!doctorDetails) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Avijo</Breadcrumb.Item>
            <Breadcrumb.Item href="/DoctorList">Doctor List</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {doctorDetails.fullName ||
                doctorDetails.personalDetails?.fullName ||
                "N/A"}
            </Breadcrumb.Item>
          </Breadcrumb>
          <h4>Doctor Details</h4>
        </div>
      </div>

      <Table striped bordered hover className="mb-4">
        <tbody>
          <tr>
            <td>Full Name</td>
            <td>
              {doctorDetails.fullName ||
                doctorDetails.personalDetails?.fullName ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Gender</td>
            <td>
              {doctorDetails.gender ||
                doctorDetails.personalDetails?.gender ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Date of Birth</td>
            <td>
              {doctorDetails.dateOfBirth
                ? moment(doctorDetails.dateOfBirth).format("YYYY-MM-DD")
                : doctorDetails.personalDetails?.dob
                ? moment(doctorDetails.personalDetails.dob, "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                  )
                : "N/A"}
            </td>
          </tr>
          <tr>
            <td>Title</td>
            <td>
              {doctorDetails.title ||
                doctorDetails.personalDetails?.title ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>City</td>
            <td>
              {doctorDetails.city ||
                doctorDetails.addressPerKyc?.district ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>State</td>
            <td>
              {doctorDetails.state ||
                doctorDetails.addressPerKyc?.state ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Country</td>
            <td>
              {doctorDetails.country ||
                doctorDetails.addressPerKyc?.country ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Colony/Street/Locality</td>
            <td>
              {doctorDetails.colonyStreetLocality ||
                doctorDetails.addressPerKyc?.address ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Pin Code</td>
            <td>
              {doctorDetails.pinCode ||
                doctorDetails.addressPerKyc?.pincode ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>College/University</td>
            <td>
              {doctorDetails.collegeUniversity ||
                doctorDetails.qualificationDetails?.college ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Degree</td>
            <td>
              {doctorDetails.degree ||
                doctorDetails.qualificationDetails?.degreeName ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Experience</td>
            <td>{doctorDetails.experience || 0} years</td>
          </tr>
          <tr>
            <td>Specialization</td>
            <td>
              {doctorDetails.specialization ||
                doctorDetails.systemOfMedicine?.systemOfMedicine ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Registration Council</td>
            <td>
              {doctorDetails.registrationCouncil ||
                doctorDetails.registrationDetails?.registerWithCouncil ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Registration Number</td>
            <td>
              {doctorDetails.registrationNumber ||
                doctorDetails.registrationDetails?.registrationNumber ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>Registration Year</td>
            <td>
              {doctorDetails.registrationYear
                ? doctorDetails.registrationYear
                : doctorDetails.registrationDetails?.dateOfRegistration
                ? moment(doctorDetails.registrationDetails.dateOfRegistration).format(
                    "YYYY"
                  )
                : "N/A"}
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};
